import ManagementDashboard from "./ManagementDashboard";
export default function Spreadsheets() {
  return (
    <section>
      <div className="min-h-screen container mx-auto my-10">
        <p className="text-2xl">Spreadsheets</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mx-3 md:mx-10">
          <div className="card bg-base-100 shadow-xl"></div>
        </div>
        <div>
          <ManagementDashboard />
        </div>
      </div>
    </section>
  );
}
